import { render, staticRenderFns } from "./bannerPop.vue?vue&type=template&id=53201162&scoped=true"
import script from "./bannerPop.vue?vue&type=script&lang=js"
export * from "./bannerPop.vue?vue&type=script&lang=js"
import style0 from "./bannerPop.vue?vue&type=style&index=0&id=53201162&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53201162",
  null
  
)

export default component.exports